import React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import ReactPaginate from "react-paginate";

const Pagination = ({ pageCount, onPageChange }) => {
  return (
    <div className="flex justify-center items-center py-4">
      <ReactPaginate
        breakLabel="..."
        nextLabel={
          <FaChevronRight className="text-red-500 hover:text-red-600" />
        }
        onPageChange={onPageChange}
        pageRangeDisplayed={4}
        pageCount={pageCount}
        previousLabel={
          <FaChevronLeft className="text-red-500 hover:text-red-600" />
        }
        containerClassName="flex items-center space-x-2"
        pageClassName="group"
        pageLinkClassName="px-3 py-1 rounded-full text-white  hover:bg-red-300 transition-all duration-300"
        activeClassName="bg-red-500 text-white rounded-full"
        activeLinkClassName="px-3 py-1 rounded-full text-white bg-red-500"
        breakClassName="px-2 text-gray-400"
      />
    </div>
  );
};

export default Pagination;
